import React from "react";
import { I18nextProvider } from "react-i18next";
import i18n from "./App/core/i18n";
import Main from "./App/core/Main";

const App = () => {
  return (
    <I18nextProvider i18n={i18n}>
      <div className="App">
        <Main />
      </div>
    </I18nextProvider>
  );
};

export default App;
